import { render, staticRenderFns } from "./JpmbUpDateStudent.vue?vue&type=template&id=98af987a&scoped=true&"
import script from "./JpmbUpDateStudent.vue?vue&type=script&lang=js&"
export * from "./JpmbUpDateStudent.vue?vue&type=script&lang=js&"
import style0 from "./JpmbUpDateStudent.vue?vue&type=style&index=0&id=98af987a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98af987a",
  null
  
)

export default component.exports